import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import FullScreen from "../assets/fullscreen.svg";
import CardBottomOverlay from "./CardBottomOverlay";
import illustratorImg from "../assets/chartillustratorImg.png";
import righarrow from "../../../assets/images/dashboard/dashboard_chart/rightArrowimg.png";
import leftarrow from "../../../assets/images/dashboard/dashboard_chart/leftArrowImg.png";
import { Box, Tooltip as MuiTooltip } from "@mui/material";

// Custom legend
// const renderSquareLegend = (props: any) => {
//   const { payload } = props;
//   return (
//     <div
//       style={{
//         display: "flex",
//         flexWrap: "wrap", // ✅ allows wrapping
//         gap: "8px",
//         justifyContent: "flex-start",
//         margin: "30px",
//         marginBottom: "20px",
//         marginTop: "0px",
//       }}
//     >
//       {payload.map((entry: any, index: number) => (
//         <div
//           key={`item-${index}`}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "5px",
//             whiteSpace: "nowrap", // ✅ keeps each legend label intact
//           }}
//         >
//           <div
//             style={{
//               width: 12,
//               height: 12,
//               backgroundColor: entry.color,
//               borderRadius: 2,
//             }}
//           ></div>
//           <span
//             style={{ fontSize: 12, color: "#5c5c5c", fontFamily: "Mazzard" }}
//           >
//             {entry.value}
//           </span>
//         </div>
//       ))}
//     </div>
//   );
// };



const CustomXAxisTick = (props: any & { totalTicks: number }) => {
  const { x, y, payload, isCandidate, data, totalTicks } = props;
  const text = payload.value;

  // Find the full data row that matches this tick
  const row = data.find((item: any) => item.stage === text);

  // Parse the dateTime string and convert time to IST
  let datePart = "";
  let timePart = "";

  if (row && row.dateTime) {
    try {
      const [date, time] = row.dateTime.split(", ");
      datePart = date;

      const [hours, minutes, seconds] = time.split(":").map(Number);
      let istHours = hours + 5;
      let istMinutes = minutes + 30;

      if (istMinutes >= 60) {
        istHours += 1;
        istMinutes -= 60;
      }
      istHours = istHours % 24;

      const period = istHours >= 12 ? "PM" : "AM";
      const displayHours = istHours % 12 || 12;

      timePart = `${displayHours.toString().padStart(2, "0")}:${istMinutes
        .toString()
        .padStart(2, "0")} ${period}`;
    } catch (error) {
      const [date, time] = row.dateTime.split(", ");
      datePart = date;
      timePart = time;
    }
  }

  // ✅ Show full text if only one tick, else truncate long ones
  const maxLength = 12;
  const isLong = text.length > maxLength && totalTicks > 1;
  const displayText =
    totalTicks === 1 ? text : isLong ? text.slice(0, maxLength) + "..." : text;

  const fontSize = isCandidate ? 10 : 14;

  return (
    <g transform={`translate(${x},${y})`}>
      <MuiTooltip
        title={
          row ? (
           <div> 
            <span>
              </span>
              <span>{text}</span>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "auto 1fr", // key fixed, value flexible
                columnGap: "8px",
                whiteSpace: "pre-line",
              }}
            >
              
              <span>
                <strong>Date:</strong>
              </span>
              <span>{datePart}</span>

              <span>
                <strong>Time:</strong>
              </span>
              <span>{timePart} IST</span>
            </div></div>
          ) : (
            text
          )
        }
        arrow
        placement="top"
      >
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor="middle"
          fill="#666"
          fontSize={10}
          fontFamily="Mazzard"
          style={{ cursor: "pointer" }}
        >
          {displayText}
        </text>
      </MuiTooltip>
    </g>
  );
};
const SkillLineChart: React.FC<{
  title: string;
  data: any[];
  skills: { key: string; label: string; color: string }[];
  bg: any;
  heading: string;
}> = ({ title, data, skills, bg, heading }) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [xIndex, setXIndex] = useState(0); // starting index
  const ITEMS_PER_PAGE = 4; // show 4 X-axis labels at a time
const [disableChartTooltip, setDisableChartTooltip] = useState(false);

  // Slice chart data
  const paginatedData = data.slice(xIndex, xIndex + ITEMS_PER_PAGE);
  const [currentIndex, setCurrentIndex] = useState(0);
  const PAGE_SIZE = 10; // number of items to show per step

  const hasNegative = data.some((d) =>
    Object.values(d).some((v) => typeof v === "number" && v < 0),
  );
  const handleOpenOverlay = (data: {
    title: string;
    chartData?: any;
    toggleOptions?: string[];
    slidebarProgressOptions?: string[];
    slidebarResultsOptions?: string[];
  }) => {
    setIsOverlayOpen(true);
  };
  const renderSquareLegend = (
  props: any,
  setDisableChartTooltip: (v: boolean) => void
) => {  const { payload = [] } = props;
  const MAX_VISIBLE = isOverlayOpen ? 5 : 3;

  const visibleLegends = payload.slice(0, MAX_VISIBLE);
  const hiddenLegends = payload.slice(MAX_VISIBLE);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        justifyContent: "flex-start",
        // margin: "30px 30px 20px",
        marginBottom:"25px"
        
      }}
    >
      {visibleLegends.map((entry: any, index: number) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            whiteSpace: "nowrap",
          }}
        >
          <div
            style={{
              width: 12,
              height: 12,
              backgroundColor: entry.color,
              borderRadius: 2,
            }}
          />
          <span
            style={{
              fontSize: 12,
              color: "#2d2d2d",
              fontFamily: "Mazzard",
            }}
          >
            {entry.value}
          </span>
        </div>
      ))}

      {hiddenLegends.length > 0 && (
        <MuiTooltip
        onOpen={() => setDisableChartTooltip(true)}   // ✅ disable chart tooltip
  onClose={() => setDisableChartTooltip(false)} // ✅ enable chart tooltip
          arrow
          placement="bottom-start"
          title={
            <div  style={{
        maxHeight: "320px",   
        overflowY: "auto",  
        padding: "6px",
      }}>
              {hiddenLegends.map((entry: any, index: number) => (
                <div
                 
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    marginBottom: "6px",
                  }}
                >
                  <div
                    style={{
                      width: 10,
                      height: 10,
                      backgroundColor: entry.color,
                      borderRadius: 2,
                    }}
                  />
                  <span
                    style={{
                      fontSize: 12,
                      fontFamily: "Mazzard",
                      color: "#fffff",
                    }}
                  >
                    {entry.value}
                  </span>
                </div>
              ))}
            </div>
          }
        >
          <span
            style={{
              fontSize: 12,
              color: "#1a73e8",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            + {hiddenLegends.length} more
          </span>
        </MuiTooltip>
      )}
    </div>
  );
};

  return (
    <div
      style={{
        width: "48%",
        marginBottom: 32,
        background: bg,
        paddingBottom: "20px",
        paddingRight: "20px",
        paddingTop: "20px",
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center", // to vertically align items
          paddingLeft: "30px", // padding on both sides instead of just left
          paddingRight: "20px", // padding on both sides instead of just left
          width: "100%", // ensure the container takes full width
        }}
      >
        <h4
          style={{
            fontFamily: "mazzard",
            fontSize: "16px",
            color: "#2b384a",
            fontWeight: 600,
          }}
        >
          {title}
        </h4>
        <img
          style={{
            height: "20px",
            width: "20px",
            alignItems: "center",
            marginBottom: 0,
            cursor: "pointer",
          }}
          src={FullScreen}
          onClick={() =>
            handleOpenOverlay({
              title: "Jozuna Skills Performance",
              toggleOptions: ["Skills Timeline", "Assessments Results"], // dynamic per card
              slidebarProgressOptions: [],
              slidebarResultsOptions: [],
            })
          }
        ></img>
      </div>
      <CardBottomOverlay
        isOpen={isOverlayOpen}
        onClose={() => setIsOverlayOpen(false)}
      >
        <div className="engagementHeader">
          <h2
            className="engagementHeader-title"
            style={{
              fontFamily: "Mazzard",
              fontSize: "16px",
              color: "#2b384a",
              fontWeight: 600,
            }}
          >
            {heading}
          </h2>
        </div>

        <div className="dashboard-divider" style={{ marginTop: "20px" }} />
        <div
          style={{
            marginBottom: 32,
            background: bg,
            paddingBottom: "20px",
            paddingRight: "20px",
            paddingTop: "20px",
            paddingLeft: "20px",
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          <h4
            style={{
              fontFamily: "mazzard",
              fontSize: "16px",
              color: "#2b384a",
              fontWeight: 600,
              paddingLeft: "25px",
            }}
          >
            {title}
          </h4>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Left Arrow */}
            <img
              src={leftarrow}
              alt="Previous"
              onClick={() =>
                setCurrentIndex((prev) => Math.max(prev - PAGE_SIZE, 0))
              }
              style={{
                width: "45px",
                height: "45px",
                cursor: currentIndex === 0 ? "not-allowed" : "pointer",
                opacity: currentIndex === 0 ? 0.5 : 1,
              }}
            />
            <ResponsiveContainer width="100%" height={250}>
              <LineChart
                // data={data}
                data={data.slice(currentIndex, currentIndex + PAGE_SIZE)}
                margin={{ top: 0, right: 20, left: 0, bottom: 0 }}
              >
                <CartesianGrid
                  stroke="#e5eef9ff"
                  strokeDasharray="0"
                  horizontal={true}
                  vertical={false}
                />{" "}
                <XAxis
                  dataKey="stage"
                  axisLine={false}
                  tickLine={false}
                  fontSize={14}
tick={<CustomXAxisTick  totalTicks={data.length}
                      // isCandidate={isCandidate}
                      data={data}/>}                  interval={0}
                  padding={{ left: 50, right: 20 }}
                />
                <YAxis
                  domain={hasNegative ? [-100, 100] : [0, 100]}
                  tickCount={hasNegative ? 9 : 5}
                  interval={0}
                  ticks={
                    hasNegative
                      ? Array.from({ length: 9 }, (_, i) => -100 + i * 25) // [-100 ... 100]
                      : Array.from({ length: 5 }, (_, i) => i * 25) // [0,25,50,75,100]
                  }
                  axisLine={false}
                  tickLine={false}
                  tick={({ x, y, payload }) => {
                    const isZero = payload.value === 0;
                    return (
                      <text
                        x={x}
                        y={y + 4}
                        textAnchor="end"
                        fill="#101828"
                        fontSize={14}
                        fontWeight={isZero ? "bold" : "normal"}
                      >
                        {payload.value}
                      </text>
                    );
                  }}
                />
                <Tooltip
                  wrapperStyle={{ pointerEvents: "all" }}
                  content={({ active, payload, label }) => {
                     if (disableChartTooltip) return null;
                    if (active && payload && payload.length) {
                      return (
                        <div
                          style={{
                            background: "rgba(51, 51, 51, 0.9)",
                            borderRadius: "10px",
                            padding: "8px",
                            border: "1px solid #ccc",
                            color: "white",
                            maxWidth: "600px", // keeps tooltip width under control
                            maxHeight: "200px",
                            overflowY: "auto",
                          }}
                        >
                          <div
                            style={{ fontWeight: "bold", marginBottom: "5px" }}
                          >
                            {label}
                          </div>

                          {payload.map((entry, index) => (
                            <div
                              key={`tooltip-${index}`}
                              style={{
                                display: "flex",
                                // justifyContent: "space-between",
                                gap: "20px",
                                alignItems: "center",
                                marginBottom: "4px",
                              }}
                            >
                              {/* Left side: color box + name */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start", // 🔹 top-align square with first line
                                  flex: "1",
                                  minWidth: 0, // allows text wrapping
                                }}
                              >
                                <span
                                  style={{
                                    display: "inline-block",
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: entry.color,
                                    marginRight: "6px",
                                    marginTop: "6px", // 🔹 optional: nudge down a bit for better alignment
                                    flexShrink: 0,
                                  }}
                                />
                                <span
                                  style={{
                                    color: entry.color,
                                    fontSize: "14px",
                                    fontFamily: "Mazzard",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                    // maxWidth: "140px", // control wrapping width
                                  }}
                                >
                                  {entry.name}
                                </span>
                              </div>

                              {/* Right side: fixed score box */}
                              <span
                                style={{
                                  backgroundColor: entry.color,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontFamily: "Mazzard",
                                  fontSize: "12px",
                                  width: "35px",
                                  borderRadius: "6px",
                                  height: "35px",
                                  marginLeft: "8px",
                                  flexShrink: 0, // prevents shrinking
                                }}
                              >
                                {entry.value}
                              </span>
                            </div>
                          ))}
                        </div>
                      );
                    }
                    return null;
                  }}
                />
                <Legend
                  verticalAlign="top"
                  align="left"
content={(props) =>
    renderSquareLegend(props, setDisableChartTooltip)
  }                />
                {skills.map((skill) => (
                  <Line
                    key={skill.key}
                    type="linear"
                    dataKey={skill.key}
                    stroke={skill.color}
                    dot={{ r: 4 }}
                    connectNulls
                  />
                ))}
              </LineChart>
            </ResponsiveContainer>
            <img
              src={righarrow}
              alt="Next"
              onClick={() =>
              { if(data.length>10)
                setXIndex((prev) => Math.min(prev + 1, data.length - PAGE_SIZE))
              }}
              style={{
                width: "40px",
                height: "40px",
                cursor:
                  currentIndex + PAGE_SIZE >= data.length
                    ? "not-allowed"
                    : "pointer",
                opacity: currentIndex + PAGE_SIZE >= data.length ? 0.5 : 1,
              }}
            />
          </div>
        </div>
      </CardBottomOverlay>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <img
          src={leftarrow}
          alt="Previous"
          onClick={() => setXIndex((prev) => Math.max(prev - 1, 0))}
          style={{
            width: "40px",
            height: "40px",
            cursor: xIndex === 0 ? "not-allowed" : "pointer",
            opacity: xIndex === 0 ? 0.5 : 1,
          }}
        />
        <ResponsiveContainer width="100%" height={250}>
          <LineChart
            // data={data}
            data={paginatedData}
            margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
          >
            <CartesianGrid
              stroke="#e5eef9ff"
              strokeDasharray="0"
              horizontal={true}
              vertical={false}
            />
            <XAxis
              dataKey="stage"
              axisLine={false}
              tickLine={false}
              fontSize={14}
tick={<CustomXAxisTick  totalTicks={data.length}
                      // isCandidate={isCandidate}
                      data={data}/>}              interval={0}
              padding={{ left: 50, right: 20 }}
            />
            <YAxis
              domain={hasNegative ? [-100, 100] : [0, 100]}
              tickCount={hasNegative ? 9 : 5}
              interval={0}
              ticks={
                hasNegative
                  ? Array.from({ length: 9 }, (_, i) => -100 + i * 25) // [-100 ... 100]
                  : Array.from({ length: 5 }, (_, i) => i * 25) // [0,25,50,75,100]
              }
              axisLine={false}
              tickLine={false}
              tick={({ x, y, payload }) => {
                const isZero = payload.value === 0;
                return (
                  <text
                    x={x}
                    y={y + 4}
                    textAnchor="end"
                    fill="#101828"
                    fontSize={14}
                    fontWeight={isZero ? "bold" : "normal"}
                  >
                    {payload.value}
                  </text>
                );
              }}
            />
            <Tooltip
              wrapperStyle={{ pointerEvents: "all" }}
              content={({ active, payload, label }) => {
                 if (disableChartTooltip) return null;
                if (active && payload && payload.length) {
                  return (
                    <div
                      style={{
                        background: "rgba(51, 51, 51, 0.9)",
                        borderRadius: "10px",
                        padding: "8px",
                        border: "1px solid #ccc",
                        color: "white",
                        fontSize: "14px",
                        maxWidth: "400px", // keeps tooltip width under control
                        maxHeight: "190px",
                        overflowY: "auto",
                      }}
                    >
                      <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                        {label}
                      </div>
                      {payload.map((entry, index) => (
                        <div
                          key={`tooltip-${index}`}
                          style={{
                            display: "flex",
                            // justifyContent: "space-between",
                            gap: "20px",
                            alignItems: "center",
                            marginBottom: "4px",
                          }}
                        >
                          {/* Left side: color box + name */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start", // 🔹 top-align square with first line
                              flex: "1",
                              minWidth: 0, // allows text wrapping
                            }}
                          >
                            <span
                              style={{
                                display: "inline-block",
                                width: "8px",
                                height: "8px",
                                backgroundColor: entry.color,
                                marginRight: "6px",
                                marginTop: "6px", // 🔹 optional: nudge down a bit for better alignment
                                flexShrink: 0,
                              }}
                            />
                            <span
                              style={{
                                color: entry.color,
                                fontSize: "14px",
                                fontFamily: "Mazzard",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                                // maxWidth: "140px", // control wrapping width
                              }}
                            >
                              {entry.name}
                            </span>
                          </div>

                          {/* Right side: fixed score box */}
                          <span
                            style={{
                              backgroundColor: entry.color,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontFamily: "Mazzard",
                              fontSize: "12px",
                              width: "35px",
                              borderRadius: "6px",
                              height: "35px",
                              marginLeft: "8px",
                              flexShrink: 0, // prevents shrinking
                            }}
                          >
                            {entry.value}
                          </span>
                        </div>
                      ))}
                    </div>
                  );
                }
                return null;
              }}
            />

            <Legend
              verticalAlign="top"
              align="left"
content={(props) =>
    renderSquareLegend(props, setDisableChartTooltip)
  }            />
            {skills.map((skill) => (
              <Line
                key={skill.key}
                type="linear"
                dataKey={skill.key}
                stroke={skill.color}
                dot={{ r: 4 }}
                strokeWidth={2}
                connectNulls
              />
            ))}
          </LineChart>
        </ResponsiveContainer>

        <img
          src={righarrow}
          alt="Next"
          onClick={() =>
          { if(data.length>4)
            setXIndex((prev) =>
              Math.min(prev + 1, data.length - ITEMS_PER_PAGE),
            )}
          }
          style={{
            width: "40px",
            height: "40px",
            cursor:
              xIndex + ITEMS_PER_PAGE >= data.length
                ? "not-allowed"
                : "pointer",
            opacity: xIndex + ITEMS_PER_PAGE >= data.length ? 0.5 : 1,
          }}
        />
      </div>
    </div>
  );
};

const SimpleLineChart: React.FC<{ charts: any[]; heading: string }> = ({
  charts,
  heading,
}) => {
  return (
    <div style={{ background: "transparent" }}>
      <div style={{ height: "100%", overflowY: "auto" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          {charts.length > 0 ? (
            charts.map((config, index) =>
              config.data && config.data.length > 0 ? (
                <SkillLineChart
                  heading={heading}
                  key={index}
                  title={config.title}
                  data={config.data}
                  skills={config.skills}
                  bg={config.bgColor}
                />
              ) : (
                <div
                  key={index}
                  style={{
                    // height: "95vh",            // Height for the area
                    width: "100%", // Take full width
                    display: "flex", // Flexbox for centering
                    justifyContent: "center", // Horizontal center
                    alignItems: "center", // Vertical center
                    fontSize: "18px",
                    fontWeight: "500",
                    color: "#6666",
                  }}
                >
                  No Data Found
                </div>
              ),
            )
          ) : (
            <div
              style={{
                fontSize: "18px",
                fontWeight: "500",
                color: "#999",
                display: "flex",
                flexDirection: "column", // stack vertically
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                textAlign: "center",
              }}
            >
              <img
                src={illustratorImg}
                style={{
                  height: "400px",
                  width: "470px",
                  marginBottom: "20px",
                }}
                alt="No Data"
              />
              <span style={{ fontFamily: "MazzardMedium", color: "#272727" }}>
                No concepts performance{" "}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimpleLineChart;
